<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<div class="content-heading loco-inforamation-header">
	<h3>{{locoLabel?.locomotiveInformation|uppercase}}</h3>
</div>
<table class="table table-no-border two-col-tbl" *ngIf="tab?.mode!='edit'">
	<tbody>
		<tr>
			<td>{{locoLabel?.class}}</td>
			<td>{{locoData?.clazz|locoBlankString}}</td>
		</tr>
		<tr>
			<td>{{locoLabel?.hp}}</td>
			<td>{{locoData?.horsePower|locoBlankString}}</td>
		</tr>
		<tr>
			<td>{{locoLabel?.te}}</td>
			<td>{{locoData?.tractiveEffort|locoBlankString}}</td>
		</tr>
		<tr>
			<td style="vertical-align:top">{{locoLabel?.allocation}}</td>
			<td *ngIf="returnDash([locoData?.locoAllocPermFlag,locoData?.locoAllocType,locoData?.locoAllocStation,locoData?.locoAllocDiv])">-</td>
			<td style="vertical-align:top" *ngIf="!returnDash([locoData?.locoAllocPermFlag,locoData?.locoAllocType,locoData?.locoAllocStation,locoData?.locoAllocDiv])">
				<p>{{locoData?.locoAllocStation}}</p>
				<p>{{locoData?.locoAllocDiv}}</p>
				<p>{{locoData?.locoAllocType}} {{'Y'===locoData?.locoAllocPermFlag?'Permanent':''}}</p>
			</td>
		</tr>
		<tr>
			<td>{{locoLabel?.permanentTag}}</td>
			<td>{{locoData?.permanentTag|locoBlankString}}</td>
		</tr>
		<tr>
			<td>{{locoLabel?.locomotiveTag}}</td>
			<td>{{locoData?.locoTag|locoBlankString}}</td>
		</tr>
		<tr>
			<td>{{locoLabel?.responsibleRoad}}</td>
			<td>{{locoData?.responsibleRoad|locoBlankString}}</td>
		</tr>
		<tr>
			<td>{{locoLabel?.intgRoad}}</td>
			<td>{{locoData?.interchangeRoad|locoBlankString}}</td>
		</tr>
		<tr>
			<td>{{locoLabel?.direction}}</td>
			<td>{{(locoData?.directionFacing && locoData?.directionFacing === 'F') ? 'Forward' : (locoData?.directionFacing && locoData?.directionFacing
				=== 'B') ? 'Backward' : (locoData?.directionFacing && locoData?.directionFacing === ' ')?'Unknown':'-'}}</td>
		</tr>
		<tr>
			<td>{{locoLabel?.telemetry}}</td>
			<td>{{locoData?.rduInstalled|locoBlankString}}</td>
		</tr>
		<tr>
			<td>{{locoLabel?.remarks}}</td>
			<td>{{locoData?.remarks|locoBlankString}}</td>
		</tr>
	</tbody>
</table>
<div *ngIf="tab?.mode==='edit'" [formGroup]="locoInfoForm">
	<table class="table table-no-border two-col-tbl">
		<tbody>
			<tr>
				<td>{{locoLabel?.class}}</td>
				<td>
					<p-dropdown styleClass="{{errorMap.get('classError')?'pull-left p-dropdown p-inputfield-error':'pull-left p-dropdown'}}"
					 [options]="classValue" formControlName='clazz' tabindex="2450">
						<ng-template let-classValue pTemplate="classValue">
							<div class="p-helper-clearfix">
								<div> {{classValue.label}} </div>
							</div>
						</ng-template>
					</p-dropdown>
				</td>
			</tr>
			<tr>
				<td>{{locoLabel?.hp}}</td>
				<td>
					<input type="text" spellcheck="false" class="{{errorMap.get('horsePowerError')?'p-inputfield p-inputfield-error':'p-inputfield'}}"
					 formControlName="horsePower" (keypress)="appUtilityService.isNumber($event)" maxlength="4" tabindex="2452">
				</td>
			</tr>
			<tr>
				<td>{{locoLabel?.te}}</td>
				<td>{{locoData?.tractiveEffort|locoBlankString}}</td>
			</tr>
			<tr>
				<td style="vertical-align:top">{{locoLabel?.allocation}}</td>
				<td *ngIf="returnDash([locoData?.locoAllocPermFlag,locoData?.locoAllocType,locoData?.locoAllocStation,locoData?.locoAllocDiv])">-</td>
				<td style="vertical-align:top" *ngIf="!returnDash([locoData?.locoAllocPermFlag,locoData?.locoAllocType,locoData?.locoAllocStation,locoData?.locoAllocDiv])">
					<p>{{locoData?.locoAllocStation}}</p>
					<p>{{locoData?.locoAllocDiv}}</p>
					<p>{{locoData?.locoAllocType}} {{'Y'===locoData?.locoAllocPermFlag?'Permanent':''}}</p>
				</td>
			</tr>
			<tr>
				<td>{{locoLabel?.permanentTag}}</td>
				<td *ngIf="(user && !user.isUserManagerOrDirector)">{{locoData?.permanentTag|locoBlankString}}</td>
				<td *ngIf="(user && user.isUserManagerOrDirector)">
					<input type="text" spellcheck="false" class="{{errorMap.get('permanentTagError')?'p-inputfield p-inputfield-error':'p-inputfield'}}"
					 pattern="^[a-zA-Z0-9]+$" formControlName="permanentTag" style="text-transform: uppercase;" maxlength="2" tabindex="2453">
				</td>
				<P *ngIf="locoInfoForm.get('permanentTag').errors?.pattern" style="text-align:center; padding: 16px; color: red; font-size:16px;">
					*
				</P>
			</tr>
			<tr>
				<td>{{locoLabel?.locomotiveTag}}</td>
				<td *ngIf="(user && !user.isUserManagerOrDirector)">{{locoData?.locoTag|locoBlankString}}</td>
				<td *ngIf="(user && user.isUserManagerOrDirector)">
					<input class="{{errorMap.get('locoTagError')?'p-inputfield p-inputfield-error':'p-inputfield'}}" type="text" formControlName="locoTag"
					 pattern="^[a-zA-Z0-9]+$" style="text-transform: uppercase;" maxlength="2" spellcheck="false" tabindex="2454">
				</td>
				<P *ngIf="locoInfoForm.get('locoTag').errors?.pattern" style="text-align:center; padding: 16px; color: red; font-size:16px;">
					*
				</P>
			</tr>
			<tr>
				<td>{{locoLabel?.responsibleRoad}}</td>
				<td *ngIf="locoData?.permanentTag==='FL'">
					<input type="text" spellcheck="false" maxlength="4" class="{{errorMap.get('responsibleRoadError')?'p-inputfield p-inputfield-error':'p-inputfield'}}"
					 formControlName="responsibleRoad" tabindex="2455" style="text-transform: uppercase;">
				</td>
				<td *ngIf="locoData?.permanentTag!=='FL'">{{locoData?.responsibleRoad|locoBlankString}}</td>
			</tr>
			<tr>
				<td>{{locoLabel?.intgRoad}}</td>
				<td>{{locoData?.interchangeRoad|locoBlankString}}</td>
			</tr>
			<tr>
				<td>{{locoLabel?.direction}}</td>
				<td>
					<p-dropdown styleClass="{{errorMap.get('directionFacingError')?'pull-left p-dropdown p-inputfield-error':'pull-left p-dropdown'}}"
					 [options]="locoDirection" formControlName='directionFacing' tabindex="2456">
						<ng-template let-locoDirection pTemplate="locoDirection">
							<div class="p-helper-clearfix">
								<div> {{locoDirection.label}} </div>
							</div>
						</ng-template>
					</p-dropdown>
				</td>
			</tr>
			<tr>
				<td>{{locoLabel?.telemetry}}</td>
				<td *ngIf="locoData?.permanentTag!=='FL' && (user && !user.isUserManagerOrDirector)">{{locoData?.rduInstalled|locoBlankString}}</td>
				<td *ngIf="locoData?.permanentTag==='FL'">
					<input style="text-transform: uppercase;" class="{{errorMap.get('rduInstalledError')?'p-inputfield p-inputfield-error':'p-inputfield'}}"
					 type="text" formControlName="rduInstalled" tabindex="2457" maxlength="1" spellcheck="false">
				</td>
				<td *ngIf="locoData?.permanentTag!=='FL' && (user && user.isUserManagerOrDirector)">
					<input style="text-transform: uppercase;" class="{{errorMap.get('rduInstalledError')?'p-inputfield p-inputfield-error':'p-inputfield'}}"
					 type="text" formControlName="rduInstalled" spellcheck="false" tabindex="2457" maxlength="1">
				</td>
			</tr>
			<tr>
				<td>{{locoLabel?.remarks}}</td>
				<td>
					<input type="text" spellcheck="false" maxlength="15" class='p-inputfield remarks-field train-placeholder'
					 formControlName="remarks" tabindex="2458">
				</td>
			</tr>
		</tbody>
	</table>
</div>
